var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingMaterials = function SvgBuildingMaterials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 17a4 4 0 0 1-.985-.142L22.154 24H17v-1h4.268l.78-6.473c-2.25-.94-5.027-3.25-5.927-6.527h-5.955l.362 3H9.521l-.482-4h14.924l-.582 4.829a7 7 0 0 1-.951-.471L22.835 10h-5.676c1.217 3.9 5.312 6 6.842 6zM0 20h7v4H0zm1 3h5v-2H1zm7-3h7v4H8zm1 3h5v-2H9zm2-4H4v-4h7zm-1-3H5v2h5zm-7.766 2a63 63 0 0 1-.249-5.572c0-5.681.787-9.765 1.036-10.916C4.056 1.379 7.292 1 10.5 1s6.42.379 7.45.512c.16.738.54 2.688.792 5.488h1.007c-.39-4.139-.819-5.665-.986-6.385C18.265.55 14.818.023 10.499 0c-4.321.023-7.79.55-8.292.615-.15.686-1.194 4.563-1.222 11.812 0 2.06.103 3.941.246 5.572h1.003z"
  })));
};
export default SvgBuildingMaterials;